module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_05_sunset-675f5fc2b6320fd9bdd58d842e7e45eb.jpg";